export type TemplatesFilterChip = 'All' | string;
export type TemplatesViewMode = 'cards' | 'table';

const CATEGORY_BADGE_STYLES: Record<string, string> = {
  marketing: 'bg-green-50 text-green-700',
  utility: 'bg-yellow-50 text-yellow-700',
  authentication: 'bg-blue-50 text-blue-700',
  development: 'bg-slate-100 text-slate-700',
};

const normalizeCategoryKey = (category: string) => category.trim().toLowerCase().replace(/\s+/g, '_');

export const getCategoryBadgeStyle = (category: string): string => {
  const key = normalizeCategoryKey(category);
  return CATEGORY_BADGE_STYLES[key] ?? 'bg-slate-100 text-slate-700';
};
